import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'BaseServices/main-service';
import { EquipmentDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';

@Component({
  selector: 'app-equipment-docs-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './equipment-docs-tab.component.html',
  styleUrl: './equipment-docs-tab.component.css',
})
export class EquipmentDocsTabComponent implements OnInit {

  equipmentId = 0;
  hasEquipmentImage = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private mainService: MainService
  ) { }

  ngOnInit(): void {

    this.activatedRoute.parent?.paramMap.subscribe(params => {

      this.equipmentId = Number(params.get('id') ?? 0);

      if (!this.equipmentId) return;

      this.loadEquipment(this.equipmentId);

    });

  }

  private loadEquipment(id: number): void {

    this.mainService.get<EquipmentDetailDTO>('Equipment', id).subscribe({
      next: (equipment) => {

        const eq: any = equipment;

        this.hasEquipmentImage = !!(eq.EquipmentImage ?? eq.equipmentImage);

      },
      error: (err) => {
        console.error('Could not load equipment', err);
      }
    });

  }

  downloadImage(): void {

    const url = `/api/Equipment/${this.equipmentId}/equipment-image`;

    const link = document.createElement('a');
    link.href = url;
    link.download = `equipment-${this.equipmentId}.png`;
    link.click();

  }

}
